module.exports = __webpack_public_path__ + "static/media/localizacao-imovel-anage.13e88e23.webp";